import React from "react";
import GitHubIcon from "@material-ui/icons/GitHub";
import LaunchRoundedIcon from "@material-ui/icons/LaunchRounded";

const linkClass =
    "flex h-8 w-8 items-center justify-center rounded-full text-ink-dim " +
    "transition-all duration-300 ease-soft hover:-translate-y-0.5 hover:text-accent";

const ExternalLinks = ({ githubLink, openLink, label = "project" }) => (
    <span className="flex items-center gap-1">
        {githubLink && (
            <a
                href={githubLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${label} on GitHub`}
                className={linkClass}
            >
                <GitHubIcon style={{ fontSize: 19 }} />
            </a>
        )}
        {openLink && (
            <a
                href={openLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open ${label}`}
                className={linkClass}
            >
                <LaunchRoundedIcon style={{ fontSize: 19 }} />
            </a>
        )}
    </span>
);

export default ExternalLinks;
